export const NC_KINDS = [
  { value: 'devolucion', label: 'Devolución de mercadería' },
  { value: 'pronto_pago', label: 'Bonificación por pronto pago' },
  { value: 'bonificacion', label: 'Bonificación comercial' },
  { value: 'error_facturacion', label: 'Error de facturación' },
  { value: 'otro', label: 'Otro' },
];

// NC anteriores a la columna kind: se infiere por si tocaron stock.
export const ncKindLabel = (nc: { kind?: string | null; affectsStock?: number | boolean }) =>
  NC_KINDS.find(k => k.value === nc.kind)?.label || (nc.affectsStock ? 'Devolución de mercadería' : 'Ajuste');
